import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface CollectionCodeAuditFilters {
  request_id?: string;
  error_code?: string;
  event_type?: string;
  operation?: string;
  store_id?: string;
  store_name?: string;
  key_name?: string;
  code?: string;
  success?: boolean | string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

export const useGetCollectionCodeAuditLogs = (
  filters: CollectionCodeAuditFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.COLLECTION_CODE_AUDIT_LOGS, filters],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );
};
